import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import SliderListItem from '../../../../../../list-items/SliderListItem/SliderListItem';
import { previewHistoryBatch } from '../../../../store/extensions';

const BackdropHlsAdjustmentHueListItem = (props) => {
    const { updateBackgroundSettings, maxHlsAdjustmentHue, minHlsAdjustmentHue, hlsAdjustmentHue } = props;

    const onHueChange = (value) => {
        previewHistoryBatch.start()
        updateBackgroundSettings({ hlsAdjustment: { hue: value } });
    }

    return (
        <SliderListItem
            title='Hue'
            value={hlsAdjustmentHue}
            displayMultiplier={1}
            min={minHlsAdjustmentHue}
            max={maxHlsAdjustmentHue}
            step={0.1}
            onValueChange={onHueChange}
            hideArrows
            preventRound
        />
    );
};

const mapStateToProps = (state) => {
    const hlsAdjustmentHue = state.createPreview.present.videoSettings.background.hlsAdjustment.hue;

    const {
        minHlsAdjustmentHue,
        maxHlsAdjustmentHue,
    } = state.create.maxValues;

    return {
        hlsAdjustmentHue,
        maxHlsAdjustmentHue,
        minHlsAdjustmentHue
    }
}

const mapDispatchToProps = (dispatch) => {
    const updateBackgroundSettings = (properties) => dispatch(createActions.updateBackgroundSettings(properties));
    return { updateBackgroundSettings }
}

export default connect(mapStateToProps, mapDispatchToProps)(BackdropHlsAdjustmentHueListItem);